import { merge } from '@fluentui/react';
import { map } from 'lodash';
/**
 * Converts an enum type object into a IContextMenuOptionList that can be used to render drop down menus.
 * Currently only supports one level of sub-options.
 */
export const getIContextualMenuOptionListFromEnum = (enumToConvert, onItemClick) => {
    const allOptions = Object.entries(enumToConvert).map(([key, data]) => {
        return Object.assign({ key }, data);
    });
    const rootOptions = allOptions.filter(item => item.groupName === undefined && item.key !== 'Unknown');
    return [
        {
            key: 'Select option',
            text: 'Select option',
            value: null,
        },
        ...rootOptions.map(item => mapMetaToIContextualMenuItem(item, allOptions, onItemClick)),
    ];
};
/**
 * Extracted method to map individual items. Was
 * extracted to allow recursive execution.
 *
 * > WARNING: this is a recursive method!
 */
const mapMetaToIContextualMenuItem = (item, allOptions, onItemClick) => {
    const currSubOptions = allOptions.filter(option => option.groupName === item.key);
    const hasSubItems = currSubOptions.length > 0;
    const isSplit = hasSubItems && !item.isHeaderOnly;
    // Option without subMenuProps
    const baseOption = {
        key: item.key,
        value: item.key,
        text: item.displayName,
        split: isSplit,
        // OnClick only matters if there's a submenu list
        onClick: isSplit ? onItemClick : undefined,
    };
    if (currSubOptions.length > 0) {
        const subMenuItems = map(currSubOptions, option => mapMetaToIContextualMenuItem(option, allOptions, onItemClick));
        return merge({}, baseOption, {
            onClick: onItemClick,
            subMenuProps: {
                onItemClick,
                items: subMenuItems,
            },
        });
    }
    else {
        return baseOption;
    }
};
